module.exports = __webpack_public_path__ + "assets/icons/ic_unfold_24px.svg";